import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import Draggable from "react-draggable";
import StepsWizard from "../../../components/scheduling/StepsWizard";
import Matching from "../../../components/scheduling/Matching";
import Details from "../../../components/scheduling/Details";
import EditEventDetails from "../../../components/scheduling/EditEventDetails";
import ViewEventDetails from "../../../components/scheduling/ViewEventDetails";
import { getActiveOrders } from "../../../components/util/helpers";
import { FormattedMessage } from "react-intl";
import moment from "moment";

const EventModal = (props) => {
  const {
    visible,
    submitEvent,
    handleCancel,
    removeEvent,
    activeEvent,
    changeActiveEvent,
    mode,
    orders,
    currentDate,
    onChosenEmployee,
    onRemoveEmployee,
    onTariffChanged,
    onUseEmployeeTariffChanged,
    onTransportationChanged,
    onOncallChange,
    changeEvent,
    editLoading,
    originalEmployeeId,
    patient,
  } = props;

  const [disabled, setDisabled] = useState(true);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!visible) {
      setCurrent(0);
    }
  }, [visible]);

  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };

  const onChangeSlide = (c) => {
    setCurrent(c);
  };

  const activeOrders = getActiveOrders(currentDate, orders);
  const steps =
    mode === "new"
      ? [
          {
            title: null,
            comp: (
              <Details
                orders={activeOrders.filter((j) => !j?.supporting_community)}
                activeEvent={activeEvent}
                removeEvent={removeEvent}
                mode={mode}
                onChangeSlide={onChangeSlide}
                title={<FormattedMessage id="app.scheduling.createNewEvent" />}
                type="scheduling"
                changeActiveEvent={changeActiveEvent}
              />
            ),
          },
          {
            title: null,
            comp: (
              <Matching
                activeEvent={{
                  ...activeEvent,
                  duration_minutes: activeEvent
                    ? moment
                        .duration(
                          moment(activeEvent.end).diff(
                            moment(activeEvent.start)
                          )
                        )
                        .asMinutes()
                    : 0,
                }}
                onChosenEmployee={onChosenEmployee}
                onRemoveEmployee={onRemoveEmployee}
                onTariffChanged={onTariffChanged}
                onUseEmployeeTariffChanged={onUseEmployeeTariffChanged}
                onOncallChange={onOncallChange}
                onTransportationChanged={onTransportationChanged}
                onChangeSlide={onChangeSlide}
                submitEvent={submitEvent}
                type="scheduling"
                orders={orders}
                originalEmployeeId={originalEmployeeId}
                patient={patient}
              />
            ),
          },
        ]
      : mode === "edit" && !(activeEvent && activeEvent["prospectus_id"])
      ? [
          {
            title: null,
            comp: (
              <EditEventDetails
                activeEvent={activeEvent}
                removeEvent={removeEvent}
                mode={mode}
                title={<FormattedMessage id="app.scheduling.editScheduling" />}
                type="scheduling"
                onChangeSlide={onChangeSlide}
                changeActiveEvent={changeActiveEvent}
                handleCancel={handleCancel}
                changeEvent={changeEvent}
                editLoading={editLoading}
                onTariffChanged={onTariffChanged}
                onUseEmployeeTariffChanged={onUseEmployeeTariffChanged}
                onTransportationChanged={onTransportationChanged}
                onOncallChange={onOncallChange}
                orders={orders}
              />
            ),
          },
          {
            title: null,
            comp: (
              <Matching
                activeEvent={{
                  ...activeEvent,
                  duration_minutes: activeEvent
                    ? moment
                        .duration(
                          moment(activeEvent.end).diff(
                            moment(activeEvent.start)
                          )
                        )
                        .asMinutes()
                    : 0,
                }}
                onChosenEmployee={onChosenEmployee}
                onRemoveEmployee={onRemoveEmployee}
                onTariffChanged={onTariffChanged}
                onUseEmployeeTariffChanged={onUseEmployeeTariffChanged}
                onTransportationChanged={onTransportationChanged}
                onOncallChange={onOncallChange}
                onChangeSlide={onChangeSlide}
                submitEvent={submitEvent}
                type="scheduling"
                orders={orders}
                originalEmployeeId={originalEmployeeId}
                patient={patient}
              />
            ),
          },
        ]
      : [
          {
            title: null,
            comp: (
              <ViewEventDetails
                activeEvent={activeEvent}
                removeEvent={removeEvent}
                mode={mode}
                title={<FormattedMessage id="app.scheduling.viewScheduling" />}
                type="scheduling"
                changeActiveEvent={changeActiveEvent}
                handleCancel={handleCancel}
                changeEvent={changeEvent}
                editLoading={editLoading}
                onTariffChanged={onTariffChanged}
                onUseEmployeeTariffChanged={onUseEmployeeTariffChanged}
                onTransportationChanged={onTransportationChanged}
                orders={orders}
              />
            ),
          },
        ];
  return (
    <Modal
      maskClosable={false}
      title={null}
      destroyOnClose={true}
      width={"max-content"}
      styles={{
        body: {
          padding: "2px 0 0 0",
        },
      }}
      closable={false}
      open={visible && (mode !== "new" || activeOrders.length > 0)}
      onCancel={handleCancel}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
      className={"no-padding"}
      footer={null}
      style={{
        top: 10,
      }}
    >
      <StepsWizard
        steps={steps}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        onChangeSlide={onChangeSlide}
        current={current}
        handleCancel={handleCancel}
      />
    </Modal>
  );
};

export default EventModal;
